import { Blockquote, Table, Text } from "@radix-ui/themes";
import {
  BookingDuration,
  bookingDurations,
  formatCurrencyFromCents,
  tariffDurationLabels,
} from "use-smart-locks-shared";
import { useUnit } from "../../hooks/use-unit";

export const TariffPricing: React.FC<{
  tariffPricesInCents: Record<BookingDuration, number>;
}> = ({ tariffPricesInCents }) => {
  const unit = useUnit();

  return (
    <>
      <Text>
        Die Miete wird nach der tatsächlichen Mietdauer zu folgenden Preisen
        abgerechnet:
      </Text>

      <Table.Root variant="surface" size="1">
        <Table.Body>
          {bookingDurations.map((duration) => (
            <Table.Row key={duration}>
              <Table.RowHeaderCell>
                {tariffDurationLabels[duration]}
              </Table.RowHeaderCell>
              <Table.Cell align="right">
                {formatCurrencyFromCents(tariffPricesInCents[duration])}
              </Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table.Root>

      {unit.basePriceInCents != null && unit.basePriceInCents > 0 && (
        <Blockquote>
          Die Abrechnung startet mit einer Grundgebühr von{" "}
          {formatCurrencyFromCents(unit.basePriceInCents)}
        </Blockquote>
      )}

      {unit.maxTotalPriceInCents != null && unit.maxTotalPriceInCents > 0 && (
        <Blockquote>
          Maximal zahlen Sie{" "}
          {formatCurrencyFromCents(unit.maxTotalPriceInCents)} pro Buchung
        </Blockquote>
      )}

      <Text size="2" color="gray">
        Die tatsächliche Mietdauer wird dabei auf die nächste Stufe aufgerundet
        – zum Beispiel werden 1 Stunde und 10 Minuten als 2 Stunden
        abgerechnet. Dauert die Miete länger als 24 Stunden, wird für jeden
        vollen 24-Stunden-Zeitraum ab Abholung ein Tagessatz berechnet, für die
        restliche Zeit gelten wieder die Preise oben.
      </Text>

      <Text>
        Zur Buchung müssen Sie ein Zahlungsmittel hinterlegen. Wir belasten
        dieses nach der Rückgabe mit
        {unit.basePriceInCents
          ? " der Grundgebühr plus dem Preis "
          : " dem Preis "}
        der erreichten Tarifstufe
        {unit.maxTotalPriceInCents
          ? ", bis maximal zum angegebenen Höchstbetrag."
          : "."}
      </Text>
    </>
  );
};
